const dispatchCustomEvent = (eventName, detail) => {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.dispatchEvent(new CustomEvent(eventName, { detail }));
    }
    catch (error) {
        console.warn('[CustomEvent] Failed to dispatch', { eventName, error });
    }
};
export default dispatchCustomEvent;
//# sourceMappingURL=dispatchCustomEvent.js.map